import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../auth/AuthProvider';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();
  const { t } = useTranslation();

  if (loading) return <div className="center-note">{t('common.loading')}</div>;
  if (!session) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
